import { CreateProductBrand, ProductBrand, UpdateProductBrand } from "../../Models/ProductBrand";
import api from "../axios";

export const productBrandService = {
  get: async (id: string): Promise<ProductBrand> => {
    const response = await api.get(`/product-brand/${id}`);
    return response.data;
  },

  getAll: async (): Promise<ProductBrand[]> => {
    const response = await api.get('/product-brand');
    return response.data;
  },

  create: async (data: CreateProductBrand): Promise<string> => {
    const response = await api.post('/product-brand', data);
    return response.data;
  },

  update: async (data: UpdateProductBrand): Promise<boolean> => {
    const response = await api.put('/product-brand', data);
    return response.data;
  },

  delete: async (id: string): Promise<boolean> => {
    const response = await api.delete(`/product-brand/${id}`);
    return response.data;
  }
};
